import { render, staticRenderFns } from "./SalesVolumeChart.vue?vue&type=template&id=17d4235e&"
import script from "./SalesVolumeChart.vue?vue&type=script&lang=js&"
export * from "./SalesVolumeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports